import * as React from 'react';
import { ArchetypeSpecificStepRunSummaryPanelProps } from '.';

export const StoreReviewStepRunSummaryPanel: React.FC<ArchetypeSpecificStepRunSummaryPanelProps> = ({ stepRun }) => {
    return <div>Store Review Step Run Summary Panel - {stepRun.displayName || stepRun.stepId}</div>;
};
